export const GLOBAL_SETTINGS = {
  request: {
    truncate: {
      name: 20,
      professionalTitle: 50
    }
  } 
}
